import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./TermsConditions.css"; // reuse the same CSS file

const RefundPolicy = () => {
  return (
    <React.Fragment>
      <Header />
      <div className="refund-policy">
        <Helmet>
          <title>Refund Policy - Happy Pay Fintech</title>
          <meta
            name="description"
            content="Refund Policy for Happy Pay Fintech services including AEPS, DMT, CMS, PAN card, and utility bill payments. Learn about our refund process, timelines, and conditions."
          />
        </Helmet>

        <div className="body-overlay"></div>

        <main>
          {/* ===== Hero / Breadcrumb ===== */}
          <section className="contact-bg pb-130 pt-195">
            <div className="container">
              <div className="row">
                <div className="col-xxl-12">
                  <div className="breadcrumb__content p-relative z-index-1">
                    <h3 className="contact-title">Refund Policy</h3>
                    <div className="breadcrumb__list">
                      <span>
                        <a href="/">Home</a>
                      </span>
                      <span className="dvdr"></span>
                      <span>Refund Policy</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* ===== Refund Policy Content inside a Card (same class as Terms) ===== */}
          <div className="container py-5">
            <div className="terms-card p-5 bg-white rounded shadow-sm">
              <h1 className="fw-bold text-center mb-4">Refund Policy</h1>
              <p className="text-center text-muted effective-date">
                Last Updated: 18.02.2026
              </p>

              <section className="mb-5">
                <h2>1. Introduction</h2>
                <p>
                  This Refund Policy ("Policy") is applicable to all services
                  provided by{" "}
                  <strong>AYYAAND PAY FINTECH PRIVATE LIMITED</strong>{" "}
                  (operating under the brand name{" "}
                  <strong>Happy Pay Fintech</strong>). By using our platform and
                  services, you agree to the terms of this Policy. We are
                  committed to ensuring a fair and transparent refund process
                  for all users, including retailers, agents, and end‑customers.
                </p>
                <p>
                  Our registered office is located at: <br />
                  <strong>AYYAAND PAY FINTECH PRIVATE LIMITED</strong>
                  <br />
                  C/o Sri B.channayya, Ter Bazar Main Road Kanakgiri, Near
                  Partana Panchayat, Kanakgiri, Koppal, Karnataka - 583283
                </p>
              </section>

              <section className="mb-5">
                <h2>2. Definitions</h2>
                <ul>
                  <li>
                    <strong>Transaction:</strong> Any financial activity
                    conducted through our platform, including but not limited to
                    AEPS, DMT, CMS, PAN card application, and utility bill
                    payments.
                  </li>
                  <li>
                    <strong>Failed Transaction:</strong> A transaction where the
                    amount is debited from the user’s account but not credited
                    to the intended beneficiary or service provider.
                  </li>
                  <li>
                    <strong>Successful Transaction:</strong> A transaction that
                    has been completed and confirmed by the beneficiary bank,
                    operator, or service provider.
                  </li>
                  <li>
                    <strong>Refund:</strong> Reversal of the debited amount back
                    to the user’s original payment source or designated bank
                    account.
                  </li>
                </ul>
              </section>

              <section className="mb-5">
                <h2>3. Applicability of Refunds</h2>
                <p>
                  Refunds may be initiated only under the following
                  circumstances:
                </p>
                <ul>
                  <li>
                    <strong>Failed Transactions:</strong> If a transaction fails
                    due to technical errors, bank downtime, or any reason on the
                    part of the payment gateway or service provider, and the
                    amount has been debited from your account.
                  </li>
                  <li>
                    <strong>Duplicate Transactions:</strong> If the same
                    transaction is processed more than once due to a system
                    error, resulting in multiple debits.
                  </li>
                  <li>
                    <strong>Technical Glitches:</strong> If our platform or a
                    partner service encounters a technical error that prevents
                    successful completion of a verified transaction.
                  </li>
                  <li>
                    <strong>Wrongly Deducted Amount:</strong> If an incorrect
                    amount is deducted from your account for a transaction.
                  </li>
                </ul>
              </section>

              <section className="mb-5">
                <h2>4. Non‑Applicability of Refunds</h2>
                <p>Refunds will not be provided in the following cases:</p>
                <ul>
                  <li>
                    <strong>Successful Transactions:</strong> Once a transaction
                    is successfully completed and the service (e.g., recharge,
                    bill payment) is delivered, no refund shall be issued.
                  </li>
                  <li>
                    <strong>User Error:</strong> If you provide incorrect
                    beneficiary details (wrong account number, wrong operator,
                    wrong amount, etc.) and the transaction is processed
                    successfully, no refund will be provided.
                  </li>
                  <li>
                    <strong>Delayed Transactions:</strong> Transactions that are
                    delayed due to bank or operator processing times but are
                    eventually successful.
                  </li>
                  <li>
                    <strong>Change of Mind:</strong> We do not offer refunds for
                    change of mind after a transaction has been initiated.
                  </li>
                  <li>
                    <strong>Disputes with Third Parties:</strong> Issues arising
                    from services provided by third parties (e.g., telecom
                    operators, electricity boards) are subject to their
                    respective policies and not covered by this refund policy.
                  </li>
                </ul>
              </section>

              <section className="mb-5">
                <h2>5. Refund Process and Timelines</h2>
                <p>
                  If you believe you are eligible for a refund, please follow
                  these steps:
                </p>
                <ol>
                  <li>
                    Contact our customer support at{" "}
                    <strong>happypayfintech@gmail.com</strong> or call us at{" "}
                    <strong>+91 9741314333</strong> within 7 days of the
                    transaction.
                  </li>
                  <li>
                    Provide your transaction ID, mobile number, registered
                    email, and a brief description of the issue.
                  </li>
                  <li>
                    Our team will verify the transaction and, if eligible,
                    initiate the refund process.
                  </li>
                </ol>
                <p>
                  Once a refund is approved, the amount will be credited back to
                  the original payment source (bank account, card, wallet, etc.)
                  within <strong>5–7 business days</strong>. In some cases,
                  depending on your bank or payment gateway, it may take up to
                  10 business days.
                </p>
              </section>

              <section className="mb-5">
                <h2>6. Refund for Specific Services</h2>
                <ul>
                  <li>
                    <strong>AEPS:</strong> If an AEPS transaction fails and the
                    amount is debited, the refund will be processed
                    automatically within 48 hours. If not received within 7
                    days, please contact support.
                  </li>
                  <li>
                    <strong>DMT (Money Transfer):</strong> For failed money
                    transfers, the amount is usually reversed by the bank within
                    3–5 working days. We will assist you in tracking the refund.
                  </li>
                  <li>
                    <strong>PAN Card Services:</strong> If your PAN application
                    is rejected by NSDL/UTI, the government fees are
                    non‑refundable. However, our service charges may be refunded
                    on a case‑by‑case basis if the rejection is due to a
                    technical error on our part.
                  </li>
                  <li>
                    <strong>Bill Payments:</strong> If a bill payment is
                    deducted but not updated by the utility provider, we will
                    coordinate with the provider. If the transaction is
                    confirmed as failed, a refund will be initiated.
                  </li>
                </ul>
              </section>

              <section className="mb-5">
                <h2>7. Dispute Resolution</h2>
                <p>
                  If you are not satisfied with the resolution provided by our
                  support team, you may escalate the matter in writing to:
                </p>
                <address>
                  <strong>AYYAAND PAY FINTECH PRIVATE LIMITED</strong>
                  <br />
                  C/o Sri B.channayya, Ter Bazar Main Road Kanakgiri, Near
                  Partana Panchayat, Kanakgiri, Koppal
                  <br />
                  Karnataka - 583283, India
                  <br />
                  Email: happypayfintech@gmail.com
                </address>
                <p>
                  We will acknowledge your complaint within 3 working days and
                  strive to resolve it within 15 days.
                </p>
              </section>

              <section className="mb-5">
                <h2>8. Contact Information</h2>
                <p>
                  For any queries related to refunds, please reach out to us:
                </p>
                <address>
                  <strong>AYYAAND PAY FINTECH PRIVATE LIMITED</strong>
                  <br />
                  Ter Bazar, Main Road, Kanakagiri,
                  <br />
                  Karnataka - 571231, India
                  <br />
                  Phone: +91 9741314333
                  <br />
                  Email: happypayfintech@gmail.com
                </address>
              </section>

              <section className="mb-5">
                <h2>9. Amendments</h2>
                <p>
                  We reserve the right to update or modify this Refund Policy at
                  any time without prior notice. Any changes will be effective
                  immediately upon posting on this page. We encourage you to
                  review this page periodically to stay informed about our
                  refund practices.
                </p>
              </section>

              <div className="text-center mt-5">
                <p className="mt-3 text-muted">
                  By using our services, you acknowledge that you have read and
                  understood this Refund Policy.
                </p>
              </div>
            </div>
          </div>
        </main>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default RefundPolicy;
